import { Component, Prop, h, Host, Element } from '@stencil/core';

const COMPONENT_NAME = 'sn-long-content-type-2';

/**
 * Full-description section for SignNow forms pages. Displays rich HTML content
 * without an image. Uses a light neutral background (--background-color-secondary).
 * On desktop the content container is 75% wide and centered. Content is sourced
 * from the `fulldescription` backend data block and rendered as raw HTML.
 *
 * @product signnow
 * @source fulldescription
 * @version 2.0.0
 * @category SignNow
 *
 * @slot body - {raw-html} - Rich HTML content (fulldescription backend block)
 * @example
 *   <sn-long-content-type-2
 *     raw-html="&lt;h2&gt;What is a W-9 form?&lt;/h2&gt;&lt;p&gt;The W-9 is an official document issued by the IRS.&lt;/p&gt;"
 *   ></sn-long-content-type-2>
 */
@Component({
  tag: 'sn-long-content-type-2',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SnLongContentType2 {
  @Element() el: HTMLElement;

  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  /**
   * Raw HTML content from the `fulldescription` backend data block.
   */
  @Prop() rawHtml?: string;

  render() {
    const rawHtml = this.rawHtml || this.el.getAttribute('rawhtml') || this.el.getAttribute('raw-html');

    return (
      <Host data-color-mode={this.colorMode}>
        <section class={COMPONENT_NAME}>
          <div class={`${COMPONENT_NAME}__container`}>
            <div class={`${COMPONENT_NAME}__content`}>{rawHtml && <div class={`${COMPONENT_NAME}__html`} innerHTML={rawHtml}></div>}</div>
          </div>
        </section>
      </Host>
    );
  }
}
